import { render, staticRenderFns } from "./kbank.vue?vue&type=template&id=8b105f78&scoped=true"
import script from "./kbank.vue?vue&type=script&lang=js"
export * from "./kbank.vue?vue&type=script&lang=js"
import style0 from "./kbank.vue?vue&type=style&index=0&id=8b105f78&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b105f78",
  null
  
)

export default component.exports